import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

interface Module {
  id: string;
  name: string;
  description: string;
}

interface Plan {
  id: string;
  code: string;
  name: string;
  created_at: string;
  modules: Module[];
}

export function usePlans() {
  return useQuery({
    queryKey: ['workspace-plans'],
    queryFn: async (): Promise<{ plans: Plan[] }> => {
      console.log('[usePlans] Fetching plans...');
      
      const { data, error } = await supabase.functions.invoke('workspace-plans', {
        body: { action: 'list' }
      });

      if (error) {
        console.error('[usePlans] Error:', error);
        throw new Error(error.message || 'Failed to fetch plans');
      }

      if (!data) {
        throw new Error('No data received from plans API');
      }

      console.log('[usePlans] Success:', { planCount: data.plans?.length || 0 });
      return data;
    },
    staleTime: 5 * 60 * 1000, // 5 minutes
    retry: 0 // Prevent retry storms
  });
}